<template>
  <div style="width: 100%">
    <div style="background: white">
      <div class="chart-buttons">
        <div>
          <i class="far fa-chevron-left" @click="getNewDateRange('previous')"></i>
          <i class="far fa-chevron-right" @click="getNewDateRange('next')" :class="{'disabled': disableNextValue}"></i>
          <span>{{formatDate(myData.start)}}</span> - <span>{{formatDate(myData.end)}}</span>
        </div>
        <div>
          <md-button :class="{'md-simple': true, 'active-button': activeButton == 'week'}" :md-ripple="false" @click="onChangeChartData('week')">Week</md-button>
          <md-button :class="{'md-simple': true, 'active-button': activeButton == 'month'}" :md-ripple="false" @click="onChangeChartData('month')">Month</md-button>
          <md-button :class="{'md-simple': true, 'active-button': activeButton == 'half-year'}" :md-ripple="false" @click="onChangeChartData('half-year')">6 Months</md-button>
          <md-button :class="{'md-simple': true, 'active-button': activeButton == 'year'}" :md-ripple="false" @click="onChangeChartData('year')">Year</md-button>
        </div>
      </div>
      <svg ref="svg" viewBox="0 0 600 250">
        <g transform="translate(50,10)">
          <g>
            <rect
              v-for="(item, index) in myData.data"
              class="bar"
              :key="index"
              :x="scaleX(item.date)"
              :y="scaleY(item.data)"
              :width="scaleX.bandwidth()"
              :height="height - scaleY(item.data)"
            >
            </rect>
          </g>
          <g ref="xAxis" :transform="`translate(0,${height})`"></g>
          <g ref="yAxis"></g>
        </g>
      </svg>

    </div>

  </div>
</template>

<script>
import activity from "@/utils/activity";
import datetime from "@/utils/datetime";

import * as d3 from "d3";
export default {
  name: 'bar-chart',
  props: {
    statistics: {
      type: Object
    },
  },
  data() {
    return {
      todayDate: this.getOnlyDay(new Date()),
      myData: {},
      outsideWidth: 600,
      outsideHeight: 250,
      activeButton: 'week',
      disableNextValue: true,
    }
  },
  computed: {
    width() {
      alert('width')
      return this.outsideWidth - 50
    },
    height() {
      // alert('height')
      return this.outsideHeight - 30
    },
    scaleX () {
      return d3.scaleBand()
          .rangeRound([0, this.outsideWidth]).padding(.3)
          .domain(this.myData.data.map(x => x.date))
    },
    // to show the X label
    formatScaleX () {
      /* take care, that there is not the same label twice. FE: 'So', 'Mo', 'Th',...,'So' */
      return d3.scaleBand()
          .rangeRound([0, this.outsideWidth]).padding(0.5)
          .domain(this.myData.data.map(x => {
            if (this.activeButton == 'half-year' || this.activeButton == 'year') {
              return this.formatMonth(new Date().setMonth(x.date - 1));
            } else if(this.activeButton == 'week') {
              return this.getDay(new Date(x.date))
            } else {
              const d = new Date(x.date)
              const y = this.formatDate(d)
              return y
            }
          }))
    },
    scaleY (data) {
      let calcY = (Math.max(...this.myData.data.map(x => x.data) ));
      let maxY = ( calcY > 20 ) ? calcY : 20;
      return d3.scaleLinear()
          .rangeRound([this.height, 0])
          .domain([0, maxY])
    },
  },
  watch: {
    myData() {
      this.disableNextValue = this.isDateBetweenRange(new Date(), this.myData.start, this.myData.end);
      this.updateXAxis()
      this.updateYAxis()
    },
    statistics(val) {
      this.setValues(val.data);
    }
  },
  created() {
    this.myData = this.getDateRange();
    this.myData.data = this.getDefaultValues();
    this.$emit('getStatistics', {start: this.myData.start, end: this.myData.end})
  },
  methods: {
    ...activity,
    ...datetime,
    updateXAxis () {
      let tickValues = this.formatScaleX.domain().filter((date, i) => { return this.activeButton != 'month'  ? i % 1 ===  0 : i % 5 === 0 })
      console.log(tickValues);
      return d3.select(this.$refs.xAxis)
          .attr('class', 'axis axis--x')
          .call(d3.axisBottom(this.formatScaleX).tickValues(tickValues))
    },
    updateYAxis () {
      d3.select(this.$refs.yAxis)
          .attr('class', 'axis axis--y')
          .call(d3.axisLeft(this.scaleY))
    },
    onChangeChartData(selectedButton) {
      this.activeButton = selectedButton;
      this.myData = this.getDateRange();
      this.myData.data = this.getDefaultValues();
      this.$emit('getStatistics', {start: this.myData.start, end: this.myData.end})
    },
    getNewDateRange(status) {
      this.myData = this.getDateRange(status);
      this.myData.data = this.getDefaultValues();
      this.$emit('getStatistics', {start: this.myData.start, end: this.myData.end})     
    },
    getDateRange(requestStatus='') {
      const currentStartDate = this.getMomentDate(this.myData.start) // this.getOnlyDay(new Date(this.myData.start));
      const currentEndDate = this.getMomentDate(this.myData.end) // this.getOnlyDay(new Date(this.myData.end));
      switch(this.activeButton) {
        case 'month':
          switch(requestStatus) {
            case 'previous':
              return { start: this.startDayOfPreviousMonth(currentStartDate), end: this.lastDayOfPreviousMonth(currentEndDate)}
              break;
            case 'next':
              return { start: this.startDayOfNextMonth(currentStartDate), end: this.lastDayOfNextMonth(currentEndDate)}
              break;
            default:
              return { start: this.startDayOfMonth(this.todayDate), end: this.lastDayOfMonth(this.todayDate)}
              break;
          }
          break;
        case 'half-year':
        case 'year':
          let months = (this.activeButton=='year') ? 12 : 6;
          switch(requestStatus) {
            case 'previous':
              return { start: this.startDayOfPreviousMonth(currentStartDate, months), end: this.lastDayOfPreviousMonth(currentEndDate, months)}
              break;
            case 'next':
              return { start: this.startDayOfNextMonth(currentStartDate, months), end: this.lastDayOfNextMonth(currentEndDate, months)}
              break;
            default:
              return { start: this.startDayOfPreviousMonth(this.todayDate, months), end: this.lastDayOfMonth(this.todayDate)}
              break;
          }
          break;
        case 'week':
        default:
          if (requestStatus == '') {
            return { start: this.addDays(this.todayDate, -6), end: this.todayDate}
          } else if (requestStatus == 'previous') {
            return { start: this.addDays(currentStartDate, -7), end: this.addDays(currentEndDate, -7)}
          } else {
            return { start: this.addDays(currentStartDate, 7), end: this.addDays(currentEndDate, 7)}
          }
          break;
      }
    },
    getDefaultValues() {
      const start = new Date(this.myData.start);
      const end = new Date(this.myData.end);
      let data = [];
      for (let i=start;i<=end;i=this.addDays(i,1)) {
        const date = this.formatDate(i, false, 'YYYY-MM-DD');
        data.push({date: date, data: 0.1});
      }
      return data;
    },
    setValues(val) {
      let myData = this.myData;
      for(let i=0;i<myData.data.length;i++) {
        let datas = val.filter(v => (v.date==myData.data[i].date))
        if(datas.length>0) {
          myData.data[i].data = datas[0].data;
        }
      }
      this.myData = Object.assign({}, myData);
    }
  }
}
</script>

<style lang="scss">
.bar-chart-container {
  display: flex;
  flex: 1 1 auto;
  .card {
    border-right: 2px solid #EDEDED;
    cursor: pointer;
  }
}
.chart-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ededed;
  margin: 0 15px;
  .far {
    margin-right: 10px;
    cursor: pointer;
    color: black;
    &.disabled {
      cursor: default;
      color: #ededed;
      pointer-events: none;
    }
  }
  .md-button {
    margin: 0 !important;
    .md-ripple {
      padding-bottom: 2px !important;
    }
  }
  .active-button {
    border-bottom: 2px solid #DF263B;
    .md-button-content {
      color: #DF263B !important;
    }

  }
}
.bar {
  fill: #005FB6;
}
.bar:hover {
  fill: #003685;
}
</style>
